import type { CityConfig } from "../city-template/types";

export const waldorfConfig: CityConfig = {
  city: "Waldorf",
  state: "Maryland",
  stateAbbr: "MD",
  slug: "waldorf",
  route: "/cities/waldorf",
  title: "Emergency Passport Waldorf, MD — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Waldorf, Maryland — as fast as 24 hours. Fast passport renewal and new passport applications for Waldorf, La Plata, White Plains, and Brandywine residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Waldorf, MD",
  heroSubtitle: "Waldorf travelers — from the St. Charles Town Center to the Southern Maryland growth corridor to the DC suburbs — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Charles County and Southern Maryland.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Modern%20suburban%20shopping%20district%20in%20Waldorf%20Maryland%20with%20St%20Charles%20Town%20Center%20area%2C%20contemporary%20retail%20buildings%20with%20warm%20lighting%2C%20clean%20landscaped%20streets%2C%20suburban%20Maryland%20architecture%20at%20golden%20hour%2C%20family-friendly%20atmosphere%2C%20no%20visible%20text%20or%20people%2C%20warm%20earth%20tones%20and%20soft%20natural%20lighting%2C%20professional%20photography%20style&width=1800&height=700&seq=waldorf-hero-001&orientation=landscape",
  heroImageAlt: "Modern suburban Waldorf Maryland shopping district at golden hour with warm lighting",
  geoPosition: "38.6265;-76.9104",
  geoPlacename: "Waldorf, Maryland",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, 1st Floor, Washington, DC 20006",
    distance: "Approximately 30–40 minutes from Waldorf via US-301 N and I-495 W",
  },
  nearbyCitiesZips: [
    { name: "Waldorf", zips: "20601, 20602, 20603, 20604" },
    { name: "La Plata", zips: "20646" },
    { name: "White Plains", zips: "20695" },
    { name: "Brandywine", zips: "20613" },
    { name: "St. Charles", zips: "20601, 20602, 20603" },
    { name: "Accokeek", zips: "20607" },
    { name: "Indian Head", zips: "20640" },
    { name: "Bryans Road", zips: "20616" },
    { name: "Pomfret", zips: "20675" },
    { name: "Hughesville", zips: "20637" },
    { name: "Bel Alton", zips: "20611" },
    { name: "Dunkirk", zips: "20754" },
    { name: "Cheltenham", zips: "20623" },
    { name: "Port Tobacco", zips: "20677" },
    { name: "Welcome", zips: "20693" },
    { name: "Marbury", zips: "20658" },
    { name: "Fort Washington, MD", zips: "20744" },
    { name: "Alexandria, VA", zips: "22301, 22302, 22304, 22305, 22306, 22307, 22308, 22309, 22310, 22311, 22312, 22314, 22315" },
    { name: "Oxon Hill, MD", zips: "20745" },
    { name: "Camp Springs, MD", zips: "20746" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier for Waldorf and Southern Maryland departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-community-line", title: "Southern Maryland Growth Corridor", desc: "Serving Charles County, Prince George's County, and Northern Virginia" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no trip to downtown DC" },
  ],
  internalLinks: [
    { name: "Expedited passport in Annapolis, MD", route: "/cities/annapolis" },
    { name: "Emergency passport help in Bethesda, MD", route: "/cities/bethesda" },
    { name: "Urgent passport services in Washington DC area", route: "/cities/alexandria-va" },
    { name: "Maryland passport services overview", route: "/states/maryland" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Waldorf, Maryland remotely via secure registered courier. We do not have a walk-in office in Waldorf — our registered couriers hand-deliver your documents to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Southern Maryland travelers without the commute to downtown DC.",
  fpcOfficeAddress: "7272 Wisconsin Ave, Bethesda, MD 20814",
  fpcOfficeDistance: "Serving Waldorf, La Plata, White Plains, Brandywine, and all of Charles County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Charles County and Southern Maryland. From the bustling St. Charles Town Center to the quiet residential communities of La Plata and White Plains, from the military families near NSWC Indian Head to the commuters traveling to DC and Alexandria — we serve all of Southern Maryland's diverse population.",
  nearbyCitiesIntro: "We serve Waldorf and nearby communities including La Plata, White Plains, Brandywine, St. Charles, Accokeek, Indian Head, Bryans Road, Pomfret, Hughesville, and all of Charles County. We also serve Prince George's County residents in Fort Washington, Oxon Hill, and Camp Springs, as well as Northern Virginia commuters in Alexandria.",
  howItWorksIntro: "Most Waldorf travelers complete everything online and ship documents overnight. No need to commute 30–40 minutes to downtown DC during rush hour.",
  mistakesIntro: "Waldorf and Southern Maryland travelers often face unique challenges due to rapid population growth and proximity to DC. Here are the most common mistakes we see from Charles County travelers.",
  testimonialsIntro: "Waldorf travelers — from military families to DC commuters to suburban professionals — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Waldorf, MD? Here are the most common ones we hear from Southern Maryland travelers.",
  statePageRoute: "/states/maryland",
  statePageName: "Maryland",
  dmvWebsite: "https://mva.maryland.gov",
  dmvLabel: "Maryland MVA — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Perfect for Southern Maryland travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 30–40 min to downtown DC", "Full day commitment — challenging for working professionals"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Waldorf travelers with immediate departure needs — as fast as 24 hours. Perfect for military travel, last-minute business trips, and unexpected family emergencies.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Military and government travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Waldorf adults with a passport issued within the last 15 years.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to Waldorf address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Waldorf residents and families — including young professionals and growing families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Waldorf residents who lost their passport before travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Waldorf families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Waldorf residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Waldorf MD", description: "Urgent passport processing for Waldorf Maryland travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Waldorf MD", description: "Fast passport renewal for Waldorf Maryland residents with a previously-issued passport." },
    { name: "First-Time Passport Waldorf MD", description: "New passport application services for Waldorf Maryland residents applying for their first passport." },
    { name: "Child Passport Waldorf MD", description: "Minor passport services for Waldorf Maryland families with children under 16." },
  ],
  testimonials: [
    {
      name: "Captain James T.",
      location: "Indian Head, MD",
      rating: 5,
      text: "Military deployment came up with 5 days notice. Fast Passport Center understood the urgency and had my passport ready in 36 hours. The agent knew exactly what military travelers need. Outstanding service for Southern Maryland.",
      service: "Emergency Passport",
    },
    {
      name: "Michelle R.",
      location: "Waldorf, MD",
      rating: 5,
      text: "Family vacation to Jamaica with 9 days notice. Three passports processed in under a week. The agent coordinated everything — we just shipped from the UPS Store on St. Charles Parkway.",
      service: "Family Passport Bundle",
    },
    {
      name: "David P.",
      location: "La Plata, MD",
      rating: 5,
      text: "Business trip to London with a week's notice. Living in La Plata, I thought I'd have to fight DC traffic. Fast Passport Center shipped everything overnight and my passport was back in 3 days. No DC commute.",
      service: "Emergency Passport",
    },
    {
      name: "Angela K.",
      location: "White Plains, MD",
      rating: 5,
      text: "Renewed my passport for a cruise to the Bahamas. The process was so simple — filled everything out online, shipped from Waldorf, and had it back in under 2 weeks. Perfect for Charles County residents.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "waldorf-1",
      name: "Waldorf Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1198 Acton Ln",
      city: "Waldorf",
      state: "MD",
      zip: "20603",
      phone: "(301) 645-6200",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "St. Charles area, near the Waldorf West shopping district",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Waldorf acceptance facility for Charles County. Appointments required — book 1–2 weeks in advance. Ample parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "waldorf-2",
      name: "Charles County Clerk's Office",
      type: "County Clerk Passport Acceptance",
      address: "200 Charles St",
      city: "La Plata",
      state: "MD",
      zip: "20646",
      phone: "(301) 932-3202",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "La Plata, approximately 8 miles south of Waldorf",
      website: "https://www.charlescountymd.gov/",
      websiteLabel: "Charles County",
      notes: "County-level facility with full passport acceptance. Extended hours compared to post office. Convenient for La Plata and southern Charles County residents.",
      icon: "ri-government-line",
    },
    {
      id: "waldorf-3",
      name: "Brandywine Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7510 Matapeake Business Dr",
      city: "Brandywine",
      state: "MD",
      zip: "20613",
      phone: "(301) 888-0670",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Brandywine, approximately 6 miles east of Waldorf",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for eastern Charles County and Brandywine residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "waldorf-4",
      name: "Accokeek Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "15717 Livingston Rd",
      city: "Accokeek",
      state: "MD",
      zip: "20607",
      phone: "(301) 203-8813",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Accokeek, approximately 12 miles north of Waldorf",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative for northern Charles County and Prince George's County residents near the border. Appointments required.",
      icon: "ri-mail-line",
    },
    {
      id: "waldorf-5",
      name: "Fort Washington Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "12819 Old Fort Rd",
      city: "Fort Washington",
      state: "MD",
      zip: "20744",
      phone: "(301) 292-4500",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Fort Washington, approximately 15 miles north of Waldorf",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative for northern Charles County residents and Prince George's County commuters. Good for travelers near the DC border.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited DC slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 30–40 min commute to downtown DC", fpc: "No — ship from Waldorf" },
    { feature: "Military Travel Support", agency: "No flexibility for deployment needs", fpc: "Yes — we handle military cases" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Southern Maryland's growing population means passport appointment slots fill quickly. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Local photo services in Waldorf and Charles County sometimes produce photos that meet general ID requirements but not passport standards. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Waldorf and Charles County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking the Acceptance Facility Early",
      description: "Waldorf Post Office appointments fill up fast, especially during summer and holiday travel seasons. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Government fees change periodically. Always verify current fees before submitting — incorrect payment means starting over.",
    },
    {
      icon: "ri-time-line",
      title: "Underestimating Routine Processing Time",
      description: "Southern Maryland residents often assume 4–6 weeks is enough. Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from your home in Waldorf, La Plata, or White Plains." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx location near St. Charles Town Center or along US-301." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Waldorf address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Waldorf, MD?", a: "Fast Passport Center offers emergency passport processing in Waldorf, Maryland in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Washington DC Passport Agency — without you needing to commute 30–40 minutes through DC traffic." },
    { q: "Does Waldorf have its own passport agency?", a: "No — neither Waldorf nor the state of Maryland has a regional passport agency. The closest facility is the Washington DC Passport Agency, approximately 30–40 minutes from Waldorf via US-301 N and I-495 W. Fast Passport Center's courier service means Southern Maryland residents never need to make that commute." },
    { q: "Can I get expedited passport services if I live in La Plata or White Plains?", a: "Absolutely. Fast Passport Center serves all of Charles County and Southern Maryland including La Plata, White Plains, Brandywine, St. Charles, Accokeek, Indian Head, Bryans Road, Pomfret, and Hughesville. We also serve Prince George's County residents in Fort Washington, Oxon Hill, and Camp Springs." },
    { q: "How much does an expedited passport cost in Waldorf, MD?", a: "Government fees are fixed: $130 for a first-time passport book or $130 + $60 expedite for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your departure timeline." },
    { q: "What airports do Waldorf travelers use for international flights?", a: "Most Waldorf residents fly internationally through Ronald Reagan Washington National Airport (DCA), approximately 25–30 minutes north via US-301 N and I-495 W. Baltimore-Washington International (BWI) is approximately 45–55 minutes northeast. Washington Dulles (IAD) is approximately 45–55 minutes northwest. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "Can I get a passport for my whole family in Waldorf?", a: "Yes. Fast Passport Center handles multi-passport cases for families in Waldorf, La Plata, White Plains, and all of Charles County. Whether you need child passports, renewals, or first-time applications for the whole family, we coordinate the process to ensure everyone is ready to travel." },
    { q: "Where is the closest passport acceptance facility to Waldorf?", a: "The Waldorf Post Office at 1198 Acton Ln is the primary acceptance facility for St. Charles and central Charles County. The Charles County Clerk's Office at 200 Charles St in La Plata offers extended hours. The Brandywine Post Office at 7510 Matapeake Business Dr serves eastern Charles County. All require appointments — book 1–2 weeks ahead." },
    { q: "How do I know if I need expedited or routine passport processing?", a: "If your travel is within 10 weeks, use expedited service. If your travel is within 2–3 weeks, use emergency expedited service. Routine processing takes 6–13 weeks and is only suitable for travel more than 3 months away. Southern Maryland residents should plan ahead, especially for military travel and family vacations." },
  ],
  photoLocations: [
    { name: "Walgreens — Waldorf", address: "3000 Waldorf Market Pl, Waldorf, MD 20603", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Waldorf", address: "3290 Crain Hwy, Waldorf, MD 20603", hours: "Mon–Sun: 8AM–10PM" },
    { name: "UPS Store — Waldorf", address: "3290 Crain Hwy, Waldorf, MD 20603", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Waldorf", address: "3020 Waldorf Market Pl, Waldorf, MD 20603", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "MVA — Waldorf", address: "11 Industrial Park Dr, Waldorf, MD 20602", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Full-service MVA for Charles County and Southern Maryland residents. REAL ID processing available.", featured: true },
    { name: "MVA — Temple Hills", address: "5600 Mable Ln, Temple Hills, MD 20748", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Alternative MVA location for northern Charles County and Prince George's County residents. Approximately 20 minutes from Waldorf.", featured: false },
  ],
  airports: [
    {
      code: "DCA",
      name: "Ronald Reagan Washington National",
      distance: "25–30 minutes from Waldorf via US-301 N and I-495 W",
      address: "2401 Smith Blvd, Arlington, VA 22202",
      note: "Primary international departure airport for Waldorf travelers. Major domestic hub with international connections. Most convenient for Southern Maryland residents.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Flight Info",
      featured: true,
    },
    {
      code: "BWI",
      name: "Baltimore-Washington International Thurgood Marshall",
      distance: "45–55 minutes from Waldorf via MD-5 N and I-695 E",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Alternative international departure airport. Direct flights to London, Cancun, Reykjavik, and the Caribbean. Southwest Airlines hub.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Flight Info",
      featured: false,
    },
    {
      code: "IAD",
      name: "Dulles International (Washington DC)",
      distance: "45–55 minutes from Waldorf via US-301 N and I-495 W",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Alternative for long-haul international flights to Europe and Asia. United Airlines hub.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Flight Info",
      featured: false,
    },
  ],
};